<template>
  <AppModal :value="value" max-width="500" @input="$emit('input', $event)">
    <template v-slot:title>
      Metadata Info
    </template>
    <template v-slot:text>
      <v-list>
        <v-list-tile>
          <v-list-tile-content>Key</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ kvPairKey }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Value</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ displayValue }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="hasUnits">
          <v-list-tile-content>Units</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ units }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Comments</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ kvValue.Comment }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list>
        <template v-if="hasFlags">
          <v-list-tile>
            <v-list-tile-content>Flag Code</v-list-tile-content>
            <v-list-tile-content class="align-end">Flag Description</v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-for="fl in kvValue.Flags" :key="fl.Id">
            <v-list-tile-content>{{ fl.FlagCode }}</v-list-tile-content>
            <v-list-tile-content class="align-end">{{ fl.Description }}</v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </template>
  </AppModal>
</template>

<script>
  import {
    calculateDisplayValue,
    isNumericType,
    kvValuePeripheralKeys,
  } from '@/helpers/kvValueHelper'
  export default {
    props: {
      kvPairKey: {
        type: String,
        required: true,
      },
      kvValue: {
        type: Object,
        required: true,
      },
      value: {
        type: Boolean,
        required: true,
      },
    },
    computed: {
      title() {
        return ''
      },
      hasFlags() {
        return this.kvValue.Flags != null && this.kvValue.Flags.length > 0
      },
      hasUnits() {
        return this.kvValue && this.valueIsNumeric && this.units
      },
      valueIsNumeric() {
        if (!(this.kvValue && this.kvValue.ValueType && this.kvValue.Value)) {
          return false
        }
        return isNumericType(this.kvValue.ValueType) && typeof(this.kvValue.Value) == 'number'
      },
      units() {
        return this.getPeripheralData(kvValuePeripheralKeys.UNITS)
      },
      significantFigures() {
        return this.getPeripheralData(kvValuePeripheralKeys.SIGFIG)
      },
      displayValue() {
        return calculateDisplayValue(this.kvValue)
      },
    },
    methods: {
      getPeripheralData(key) {
        if (!(this.kvValue && this.kvValue.PeripheralData)) {
          return null
        }
        return this.kvValue.PeripheralData[key]
      },
    },
  }
</script>